import "./TfStoreProductsStep.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {TfStoreViewStore} from "../../services/TfStoreViewStore";
import {ReplaySubject} from "rxjs";
import {ProductBillingPrices, ProductPrices} from "../../models/TfStorePrices";
import {StoreProductState, StoreProductStates} from "../../../common/models/StoreProductState";
import {TfProductMappings, TfStoreProduct} from "../../models/TfStoreProduct";

export const ProductsStep = "tfStoreProductsStep";

export function productsStep(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/products/TfStoreProductsStep.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: TfStoreProductsStepController
    };
}

export class TfStoreProductsStepController implements IOnInit, IOnDestroy {

    public viewStore: TfStoreViewStore;
    public productState: StoreProductState;

    public prices = ProductPrices;
    public billingPrices = ProductBillingPrices;
    public products = TfProductMappings;
    public setBillingCycle(cycle: "MONTH" | "YEAR"): void {
        this.viewStore.setBillingCycle(cycle);
    }

    public hasChangedProducts = false;

    private destroyed$ = new ReplaySubject<void>();

    /** @ngInject */
    public constructor(private $scope: IScope) {
    }

    public $onInit(): void {
        this.viewStore
            .productStates
            .takeUntil(this.destroyed$)
            .subscribe((states) => this.statesChanged(states));
    }

    private statesChanged(states: StoreProductStates<TfStoreProduct>) {
        this.$scope.$applyAsync(() => {
            this.productState = states.TRADEFLOOR_PRO;
            this.hasChangedProducts = this.productStateChanged(this.productState);
        });
    }

    private productStateChanged(state: StoreProductState) {
        return state.selected && !state.locked;
    }

    public toggleTestProductState() {
        this.viewStore.toggleTestProductState();
    }

    public $onDestroy(): void {
        this.destroyed$.next(void 0);
        this.destroyed$.complete();
    }
}
